import styled, { css } from 'styled-components';
import { duration, easing } from 'ui/theme';

const ANGLE = 45;
type Props = { isInfinite?: boolean; borderWidth?: number };

/**
 * In order to achieve the animated gradient outline effect with transparency and border-radius,
 * we need to create a mask that will be positioned absolutely relative to the parent element.
 * Note: As of creating this, the @property CSS at-rule is largely supported but may not work in older devices or browsers.
 */
export const OutlinePsuedoElement = ({ isInfinite, borderWidth = 1 }: Props) => css`
  --border-angle: ${ANGLE}deg;

  &::before {
    content: '';
    position: absolute;
    inset: -${borderWidth}px;
    box-sizing: border-box;
    border: inherit;
    border-radius: inherit;
    pointer-events: inherit;
    background: linear-gradient(
        var(--border-angle),
        #ff4d80,
        #fe4d81,
        #fc4e82,
        #f95086,
        #f4528a,
        #ee5490,
        #e65897,
        #de5b9f,
        #d65fa7,
        #ce62af,
        #c666b6,
        #c068bc,
        #bb6ac0,
        #b86cc4,
        #b66dc5,
        #b56dc6,
        #b56dc6,
        #ffffff 85%
      )
      border-box;
    mask: linear-gradient(black, black), linear-gradient(black, black);
    mask-clip: content-box, border-box;
    mask-composite: exclude;

    animation: bg-spin 800ms ${easing.exit}
      ${isInfinite ? ' infinite' : `, fade-out ${duration.dramatic} ${easing.exit} forwards 400ms`};

    @keyframes bg-spin {
      to {
        --border-angle: ${ANGLE + 360}deg;
      }
    }

    @keyframes fade-out {
      to {
        opacity: 0;
      }
    }

    @property --border-angle {
      syntax: '<angle>';
      inherits: true;
      initial-value: ${ANGLE}deg;
    }
  }
`;

const Outline = styled.div<Props>`
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  border: ${({ borderWidth }) => borderWidth || 1}px solid transparent;
  border-radius: inherit;
  ${(props) => OutlinePsuedoElement(props)};
`;

export const GradientOutline = (props: Props) => <Outline {...props} />;
